import React from 'react';
import ReactDOM from 'react-dom/client';
import { initSdk } from './services/sdkInit';
import App from './App.tsx';
import '@codesocietyou/contentedge-cms-sdk/styles.css';
import './index.css';

initSdk();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
